import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
// import { Chat } from '../interfaces/chat.type';
// import { Files } from '../interfaces/file-manager.type';
// import { Mail } from '../interfaces/mail.type';
// import { ProjectList } from '../interfaces/project-list.type';

@Injectable({
    providedIn: 'root'
})
export class AppsService {
    constructor(private http: HttpClient) {}
    private _baseURL: string = environment.apiOrigin + '/apiv1/';

    // public getChatJSON(): Observable<Chat[]> {
    //     return this.http.get<Chat[]>("./assets/data/apps/chat-data.json")
    // }

    // public getFileManagerJson(): Observable<Files[]> {
    //     return this.http.get<Files[]>("./assets/data/apps/file-manager-data.json")
    // }

    // public getMailJson(): Observable<Mail[]> {
    //     return this.http.get<Mail[]>("./assets/data/apps/mail-data.json")
    // }

    // public getProjectListJson(): Observable<ProjectList[]> {
    //     return this.http.get<ProjectList[]>("./assets/data/apps/project-list-data.json")
    // }
    create(postdata, rte) {
        return this.http.post(this._baseURL +`/${rte}`, { data: postdata });
      }
      post(postdata, rte) {
        return this.http.post(this._baseURL +`/${rte}`, postdata);
      }
      get(rte) {
        return this.http.get(this._baseURL +`/${rte}`);
      }
    
      update(postdata, rte) {
        return this.http.put(this._baseURL +`/${rte}`, { data: postdata });
      }
      delete(rte) {
        return this.http.delete(this._baseURL +`/${rte}`);
      }
}